import {
  DEFAULT_AUTHORING_LANGUAGE,
  getStoredAuthoringLanguage,
  normalizeAuthoringLanguageCode,
  type AuthoringLibraryLanguage
} from "./authoringLibraryLanguages";
import type { AuthoringLibraryLabelKey } from "./authoringLibraryLabelKeys";
import { authoringLibraryResources } from ".";

const labelToKeyMap: Record<string, AuthoringLibraryLabelKey> = {
  "Question Paper Library": "questionPaperLibrary",
  "Assessment Library": "assessmentLibrary",
  "Question Authoring": "questionAuthoring",
  "Review Questions": "reviewQuestions",
  "Bulk Upload History": "bulkUploadHistory",
  "Bulk Action History": "bulkActionHistory",
  "Edit Question": "editQuestion",
  "Invite Participants": "inviteParticipants",
  "External User Bulk Upload History": "externalUserBulkUploadHistory",
  "Assessment Schedule": "assessmentSchedule",
  "Assessment Report": "assessmentReport"
};

function normalizeLanguageCode(language?: string): AuthoringLibraryLanguage {
  const storedLanguage = getStoredAuthoringLanguage();
  if (storedLanguage) {
    return storedLanguage;
  }

  return normalizeAuthoringLanguageCode(language);
}

export function getAuthoringLibraryLabel(
  key: AuthoringLibraryLabelKey,
  language?: string
): string {
  const langCode = normalizeLanguageCode(language);
  return (
    authoringLibraryResources[langCode]?.[key] ||
    authoringLibraryResources[DEFAULT_AUTHORING_LANGUAGE]?.[key] ||
    key
  );
}

export function localizeAuthoringLibraryBreadcrumb(
  label: unknown,
  language?: string
): unknown {
  if (typeof label === "string" && labelToKeyMap[label]) {
    return getAuthoringLibraryLabel(labelToKeyMap[label], language);
  }

  return label;
}
